export default {
	metaInfo: {
		title: 'Terms & Conditions – ImmerseFX'
	}
}
